(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2045],{

/***/ 52341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_carrousel_half_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(28447);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-gallery/src/index.tsx + 5 modules
var ab_gallery_src = __webpack_require__(96831);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/formik/dist/formik.esm.js + 5 modules
var formik_esm = __webpack_require__(92151);
// EXTERNAL MODULE: ../node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(68301);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 38 modules
var esm = __webpack_require__(52257);
// EXTERNAL MODULE: ../packages/ab-context-modal/src/index.tsx + 5 modules
var ab_context_modal_src = __webpack_require__(49796);
// EXTERNAL MODULE: ../packages/ab-context-ebox/src/index.tsx + 3 modules
var ab_context_ebox_src = __webpack_require__(13757);
// EXTERNAL MODULE: ../packages/ab-context-cart/src/index.tsx + 3 modules
var ab_context_cart_src = __webpack_require__(29359);
// EXTERNAL MODULE: ../packages/ab-input/src/index.tsx
var ab_input_src = __webpack_require__(9215);
// EXTERNAL MODULE: ../packages/ab-form-button/src/index.tsx
var ab_form_button_src = __webpack_require__(81402);
// EXTERNAL MODULE: ../packages/ab-form-dedicatoria/src/ab-form-dedicatoria.scss
var ab_form_dedicatoria = __webpack_require__(93633);
// EXTERNAL MODULE: ../node_modules/lodash-es/find.js + 1 modules
var find = __webpack_require__(56232);
// EXTERNAL MODULE: ../node_modules/lodash-es/filter.js + 1 modules
var filter = __webpack_require__(88205);
// EXTERNAL MODULE: ../packages/ab-functions/src/index.tsx + 9 modules
var ab_functions_src = __webpack_require__(5134);
;// CONCATENATED MODULE: ../packages/ab-form-dedicatoria/src/index.tsx




















var FormDedicatoria = function(param) {
    var i18n = param.i18n, products = param.products, setShowUpsellingModal = param.setShowUpsellingModal, product = param.product;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(false), loading = ref10[0], setLoading = ref10[1];
    var formRef = (0,react.useRef)();
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,ab_context_modal_src/* useModalContext */.vR)(), 2), stateModal = ref11[0], dispatchMdoal = ref11[1];
    var showModal = stateModal.showModal;
    var setShowModal = dispatchMdoal.setShowModal;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,ab_context_ebox_src/* useEboxContext */.OI)(), 2), stateEbox = ref12[0], dispatchEbox = ref12[1];
    var itemsEbox = stateEbox.itemsEbox;
    var addItemsToEbox = dispatchEbox.addItemsToEbox, resetEbox = dispatchEbox.resetEbox, setDedicatoria = dispatchEbox.setDedicatoria;
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,ab_context_cart_src/* useCartContext */.iQ)(), 2), state = ref13[0], dispatch = ref13[1];
    var addItemToCart = dispatch.addItemToCart;
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    var router = (0,next_router.useRouter)();
    var showUpselling = product === null || product === void 0 ? void 0 : (ref = product.configuradorEbox) === null || ref === void 0 ? void 0 : ref.upselling;
    var eboxFijas = product === null || product === void 0 ? void 0 : (ref1 = product.configuradorEbox) === null || ref1 === void 0 ? void 0 : ref1.fijas;
    var alojamiento1Noche = (product === null || product === void 0 ? void 0 : (ref2 = product.configuradorEbox) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.estancias) === null || ref3 === void 0 ? void 0 : ref3.length) ? (ref5 = (0,find/* default */.Z)(product === null || product === void 0 ? void 0 : (ref4 = product.configuradorEbox) === null || ref4 === void 0 ? void 0 : ref4.estancias, function(product) {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.producto) === null || ref === void 0 ? void 0 : ref.sku) == "EB00031";
    })) === null || ref5 === void 0 ? void 0 : ref5.producto : (0,find/* default */.Z)(products, function(product) {
        return (product === null || product === void 0 ? void 0 : product.sku) == "EB00031";
    });
    var alojamiento2Noche = (product === null || product === void 0 ? void 0 : (ref6 = product.configuradorEbox) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.estancias) === null || ref7 === void 0 ? void 0 : ref7.length) ? (ref9 = (0,find/* default */.Z)(product === null || product === void 0 ? void 0 : (ref8 = product.configuradorEbox) === null || ref8 === void 0 ? void 0 : ref8.estancias, function(product) {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.producto) === null || ref === void 0 ? void 0 : ref.sku) == "EB00032";
    })) === null || ref9 === void 0 ? void 0 : ref9.producto : (0,find/* default */.Z)(products, function(product) {
        return (product === null || product === void 0 ? void 0 : product.sku) == "EB00032";
    });
    var _products = (0,filter/* default */.Z)(products, function(product) {
        var ref;
        return (product === null || product === void 0 ? void 0 : product.price) || (product === null || product === void 0 ? void 0 : (ref = product.producto) === null || ref === void 0 ? void 0 : ref.price);
    });
    var formik = (0,formik_esm/* useFormik */.TA)({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: true,
        initialValues: {
            firstName: "",
            lastName: "",
            giftMsg: ""
        },
        validationSchema: yup_es/* object */.Ry().shape({
            firstName: yup_es/* string */.Z_().required(t("validationFirstName")),
            lastName: yup_es/* string */.Z_().required(t("validationLastName")),
            giftMsg: yup_es/* string */.Z_().required(t("validationDedicatoria"))
        }),
        onSubmit: function(values) {
            setLoading(true);
        // formRef.current.submit();
        }
    });
    (0,react.useEffect)(function() {
        (0,ab_functions_src/* registerLocale */.I2)();
        if (eboxFijas === null || eboxFijas === void 0 ? void 0 : eboxFijas.length) {
            if (alojamiento1Noche) {
                addItemsToEbox((0,_to_consumable_array/* default */.Z)(eboxFijas).concat([
                    alojamiento1Noche
                ]));
            } else {
                addItemsToEbox(eboxFijas);
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if ((eboxFijas === null || eboxFijas === void 0 ? void 0 : eboxFijas.length) && (itemsEbox === null || itemsEbox === void 0 ? void 0 : itemsEbox.length) < (eboxFijas === null || eboxFijas === void 0 ? void 0 : eboxFijas.length)) {
            if (alojamiento1Noche) {
                addItemsToEbox((0,_to_consumable_array/* default */.Z)(eboxFijas).concat([
                    alojamiento1Noche
                ]));
            } else {
                addItemsToEbox(eboxFijas);
            }
        }
    }, [
        product,
        eboxFijas,
        itemsEbox
    ]);
    // if (eboxFijas?.length && itemsEbox?.length < eboxFijas?.length) {
    //   addItemsToEbox(eboxFijas);
    // }
    var tempPrice = 0;
    var tempPriceToShow = numeral_default()(0).value();
    var continuar = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var addons, extraData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!showUpselling) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            setShowUpsellingModal(true);
                            setDedicatoria({
                                giftMsg: values === null || values === void 0 ? void 0 : values.giftMsg,
                                giftName: values === null || values === void 0 ? void 0 : values.firstName,
                                giftLastName: values === null || values === void 0 ? void 0 : values.lastName
                            });
                        }
                        _ctx.next = 17;
                        break;
                    case 4:
                        addons = [];
                        setLoading(true);
                        itemsEbox === null || itemsEbox === void 0 ? void 0 : itemsEbox.map(function(itm) {
                            tempPrice += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
                            tempPriceToShow += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
                        // console.log("estuchePrice", tempPriceToShow, itm);
                        });
                        addons.push({
                            display: "".concat(numeral_default()(tempPrice).format("1,000.00"), "&euro;"),
                            name: "Ebox - Price",
                            price: tempPrice,
                            value: tempPrice
                        });
                        if (values === null || values === void 0 ? void 0 : values.giftMsg) {
                            addons.push({
                                name: "Dedicatoria Experience Box",
                                price: "0",
                                value: values === null || values === void 0 ? void 0 : values.giftMsg
                            });
                        }
                        if ((values === null || values === void 0 ? void 0 : values.firstName) && (values === null || values === void 0 ? void 0 : values.lastName)) {
                            addons.push({
                                name: "Beneficiario",
                                price: "0",
                                value: (values === null || values === void 0 ? void 0 : values.firstName) + " " + (values === null || values === void 0 ? void 0 : values.lastName)
                            });
                        }
                        addons.push({
                            name: "Experiencias",
                            price: "",
                            value: itemsEbox.map(function(itm) {
                                return itm.sku;
                            }).join()
                        });
                        addons.push({
                            name: "Que incluye",
                            price: "",
                            value: itemsEbox.map(function(itm) {
                                return itm.name;
                            }).join()
                        });
                        extraData = {
                            addons: addons
                        };
                        _ctx.next = 15;
                        return addItemToCart({
                            databaseId: product === null || product === void 0 ? void 0 : product.databaseId,
                            price: tempPriceToShow
                        }, 1, null, JSON.stringify(extraData));
                    case 15:
                        resetEbox();
                        router.push(t("/cesta"));
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function continuar() {
            return _ref.apply(this, arguments);
        };
    }();
    var saltar = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var addons, extraData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!showUpselling) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            setShowUpsellingModal(true);
                        }
                        _ctx.next = 15;
                        break;
                    case 4:
                        addons = [];
                        setLoading(true);
                        itemsEbox === null || itemsEbox === void 0 ? void 0 : itemsEbox.map(function(itm) {
                            tempPrice += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
                            tempPriceToShow += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
                            ;
                        });
                        addons.push({
                            display: "".concat(numeral_default()(tempPrice).format("1,000.00"), "&euro;"),
                            name: "Ebox - Price",
                            price: tempPrice,
                            value: tempPrice
                        });
                        addons.push({
                            name: "Experiencias",
                            price: "",
                            value: itemsEbox.map(function(itm) {
                                return itm.sku;
                            }).join()
                        });
                        addons.push({
                            name: "Que incluye",
                            price: "",
                            value: itemsEbox.map(function(itm) {
                                return itm.name;
                            }).join()
                        });
                        extraData = {
                            addons: addons
                        };
                        _ctx.next = 13;
                        return addItemToCart({
                            databaseId: product === null || product === void 0 ? void 0 : product.databaseId,
                            price: tempPriceToShow
                        }, 1, null, JSON.stringify(extraData));
                    case 13:
                        resetEbox();
                        router.push(t("/cesta"));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function saltar() {
            return _ref.apply(this, arguments);
        };
    }();
    var values = formik.values, setFieldValue = formik.setFieldValue, handleSubmit = formik.handleSubmit, errors = formik.errors;
    // console.log("Form dedicatoria - ", eboxFijas);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-dedicatoria",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "h2",
                        className: "incluya",
                        children: t("dedicatoriaTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                        placeholder: t("dedicatoriaFirstName"),
                        value: values.firstName,
                        error: errors.firstName,
                        onChange: function(val) {
                            return setFieldValue("firstName", val);
                        },
                        id: "m_first_name",
                        maxLength: "40",
                        name: "first_name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                        placeholder: t("dedicatoriaLastName"),
                        value: values.lastName,
                        error: errors.lastName,
                        onChange: function(val) {
                            return setFieldValue("lastName", val);
                        },
                        id: "m_last_name",
                        maxLength: "80",
                        "data-testid": "last_name",
                        name: "last_name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                        placeholder: t("dedicatoriaComments"),
                        value: values.giftMsg,
                        error: errors.giftMsg,
                        onChange: function(val) {
                            return setFieldValue("giftMsg", val);
                        },
                        id: "m_giftMsg",
                        maxLength: "400",
                        "data-testid": "giftMsg",
                        name: "giftMsg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "p",
                        className: "obligatorios",
                        children: t("obligatorios")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_form_button_src/* default */.Z, {
                                loading: loading,
                                onClick: function() {
                                    return continuar();
                                },
                                disabled: !(values === null || values === void 0 ? void 0 : values.firstName) || !values.lastName,
                                children: t("continue")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_form_button_src/* default */.Z, {
                                loading: loading,
                                onClick: function() {
                                    return saltar();
                                },
                                children: t("saltar")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "p",
                className: "envios",
                children: t("envios-dentro-de-espana")
            })
        ]
    });
};
/* harmony default export */ var ab_form_dedicatoria_src = (FormDedicatoria);

// EXTERNAL MODULE: ../packages/ab-carrousel-half/src/carrousel-half.scss
var carrousel_half = __webpack_require__(62070);
;// CONCATENATED MODULE: ../packages/ab-carrousel-half/src/index.tsx









var CarrouselHalf = function(param) {
    var title = param.title, link = param.link, _text = param.text, text = _text === void 0 ? [] : _text, content = param.content, rtl = param.rtl, plus = param.plus, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname, _images = param.images, images = _images === void 0 ? [
        "/images/Food.png",
        "/images/Rooms.png"
    ] : _images, _imgmob = param.imgmob, imgmob = _imgmob === void 0 ? [] : _imgmob, animated = param.animated, h1 = param.h1, video = param.video, videoembed = param.videoembed, navlink = param.navlink, products = param.products, product = param.product, i18n = param.i18n, showUpsellingModal = param.showUpsellingModal, setShowUpsellingModal = param.setShowUpsellingModal;
    // console.log('CarrouselHalf', images);
    var myRef = (0,react.useRef)();
    var ref = (0,es/* useInViewport */.NM)(myRef, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref.inViewport, enterCount = ref.enterCount, leaveCount = ref.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#".concat(navlink));
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    menu.scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            navlink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "reference",
                style: {
                    top: -90
                },
                id: navlink
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "carrousel-half".concat(rtl ? " rtl" : "").concat(plus ? " plus" : "", " ").concat(className || "", " ").concat(classname || ""),
                ref: myRef,
                children: [
                    h1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "h1",
                        children: h1
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content".concat(navlink ? " ebox" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        animated: animated,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_gallery_src/* default */.Z, {
                                        images: images,
                                        imagesMobile: imgmob
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                        text: text,
                                        content: content,
                                        singleColumn: true
                                    }),
                                    (classname === null || classname === void 0 ? void 0 : classname.includes("experiencia")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_form_dedicatoria_src, {
                                        i18n: i18n,
                                        products: products,
                                        product: product,
                                        showUpsellingModal: showUpsellingModal,
                                        setShowUpsellingModal: setShowUpsellingModal
                                    }) : null,
                                    (link === null || link === void 0 ? void 0 : link.href) || (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                                        prefetch: false,
                                        href: (link === null || link === void 0 ? void 0 : link.href) || (link === null || link === void 0 ? void 0 : link.url),
                                        text: (link === null || link === void 0 ? void 0 : link.text) || (link === null || link === void 0 ? void 0 : link.title),
                                        target: link === null || link === void 0 ? void 0 : link.target
                                    }) : null
                                ]
                            }),
                            video ? video : videoembed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                width: "1216",
                                height: "600",
                                src: "".concat(videoembed.replace("https://www.youtube.com/watch?v=", "https://www.youtube-nocookie.com/embed/"), "?modestbranding=1&controls=0&showinfo=0&mode=opaque&autohide=1&wmode=transparent"),
                                frameborder: "0",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                allowfullscreen: true
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_gallery_src/* default */.Z, {
                                images: images,
                                imagesMobile: imgmob
                            }),
                            (link === null || link === void 0 ? void 0 : link.href) || (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                                prefetch: false,
                                href: (link === null || link === void 0 ? void 0 : link.href) || (link === null || link === void 0 ? void 0 : link.url),
                                text: (link === null || link === void 0 ? void 0 : link.text) || (link === null || link === void 0 ? void 0 : link.title) || "Enlace",
                                target: link === null || link === void 0 ? void 0 : link.target
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_carrousel_half_src = (CarrouselHalf);


/***/ }),

/***/ 81402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ook_loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27336);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73969);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__);






var FormButton = function(_param) {
    var loading = _param.loading, children = _param.children, onClick = _param.onClick, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "loading",
        "children",
        "onClick",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: "ab-form-button",
        type: "submit",
        onClick: onClick,
        disabled: loading || disabled
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ook_loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            loading: true,
            mini: true
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormButton);


/***/ }),

/***/ 9215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78015);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_input_scss__WEBPACK_IMPORTED_MODULE_3__);







var Input = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, value = _param.value, onChange = _param.onChange, className = _param.className, label = _param.label, placeholder = _param.placeholder, error = _param.error, parentClassName = _param.parentClassName, placeHolderClassname = _param.placeHolderClassname, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "value",
        "onChange",
        "className",
        "label",
        "placeholder",
        "error",
        "parentClassName",
        "placeHolderClassname"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var renderInput = function() {
        if (parentClassName == "at-novartis") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value: value,
                        onChange: function(e) {
                            return onChange(e.target.value);
                        },
                        placeholder: placeholder
                    }, rest)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value:  true ? "@novartis.com" : 0,
                        placeholder: placeholder
                    }, rest), {
                        disabled: true
                    }))
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : "", " ").concat(placeHolderClassname || ""),
            type: showPassword ? "text" : type,
            value: value,
            onChange: function(e) {
                return type !== "checkbox" && type !== "radio" ? onChange(e.target.value) : onChange(e.target.checked);
            },
            checked: value,
            placeholder: placeholder
        }, rest));
    };
    // if (type == "text" || type == "password") {
    //   return renderInput();
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "ab-input container ".concat(type, " ").concat(parentClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: label
            }),
            renderInput(),
            type == "password" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "password",
                role: "button",
                onClick: function() {
                    return setShowPassword(!showPassword);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: showPassword ? "/images/hide.png" : "/images/show.png",
                    style: {
                        width: 16,
                        height: 16
                    },
                    alt: showPassword ? "hide" : "show"
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "checkmark"
            }),
            error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "error",
                children: error
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 62070:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73969:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 93633:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78015:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);